var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "static-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [_c("Header", { attrs: { title: "Pagina Template" } })]
          },
          proxy: true
        },
        {
          key: "footer",
          fn: function() {
            return undefined
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "template-content" }, [
          _c("div", { staticClass: "item mb-3" }, [
            _c("h1", [_vm._v("Solo testo")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue. Habitant morbi tristique senectus et netus et malesuada fames. Blandit massa enim nec dui nunc mattis enim ut. Turpis massa tincidunt dui ut. Ultrices tincidunt arcu non sodales neque sodales ut etiam. Facilisis mauris sit amet massa vitae tortor condimentum. Nunc faucibus a pellentesque sit amet porttitor eget. Orci a scelerisque purus semper eget duis at tellus at. Tellus at urna condimentum mattis pellentesque id nibh tortor id.\n                "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item mb-3" }, [
            _c("h3", [_vm._v("Sottotitolo 1")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue. Habitant morbi tristique senectus et netus et malesuada fames. Blandit massa enim nec dui nunc mattis enim ut. Turpis massa tincidunt dui ut. Ultrices tincidunt arcu non sodales neque sodales ut etiam. Facilisis mauris sit amet massa vitae tortor condimentum. Nunc faucibus a pellentesque sit amet porttitor eget. Orci a scelerisque purus semper eget duis at tellus at. Tellus at urna condimentum mattis pellentesque id nibh tortor id.\n                "
              )
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut."
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue."
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item image my-5" }),
          _vm._v(" "),
          _c("div", { staticClass: "item d-flex image-text my-5" }, [
            _c("div", { staticClass: "image" }, [_c("div")]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("h3", [_vm._v("Solo testo")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue. Habitant morbi tristique senectus et netus et malesuada fames. Blandit massa enim nec dui nunc mattis enim ut. Turpis massa tincidunt dui ut. Ultrices tincidunt arcu non sodales neque sodales ut etiam. Facilisis mauris sit amet massa vitae tortor condimentum. Nunc faucibus a pellentesque sit amet porttitor eget. Orci a scelerisque purus semper eget duis at tellus at. Tellus at urna condimentum mattis pellentesque id nibh tortor id.\n                    "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "adjust" },
            [
              _c(
                "CarouselOne",
                { attrs: { max: 2 } },
                [
                  _c("slide", [
                    _c("div", { staticClass: "d-flex slide-image" }, [
                      _c("div")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("slide", [
                    _c("div", { staticClass: "d-flex slide-image" }, [
                      _c("div")
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2597756f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2597756f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/Template.vue
// module id = null
// module chunks = 